<template>
  <div>
      <div class="table__search">
          <el-row>
            <el-col :span="4">
              <el-button class="btn-add" @click="centerDialogVisible = true">新增职位</el-button>
            </el-col>
            <el-col :span="20">
              <DepartmentCascade align="right" size="small" ref="cascadeOne" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne1" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo1" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree1" v-on:getDepartmentFour="showDepartmentFour1" v-bind:four="parentMsgFour"></DepartmentCascade>
            </el-col>
          </el-row>
        </div>
        <div class="table__list">
          <el-table :data="currentData" style="width: 100%" class="textlist" @cell-mouse-enter="showOperate" @cell-mouse-leave="hideOperate">
            <el-table-column prop="zhiwei_name" label="职位名" align="center"></el-table-column>
            <el-table-column prop="list" label="部门" align="center" show-overflow-tooltip width="150"></el-table-column>
            <el-table-column prop="zhiwei_jibie" label="级别" align="center"></el-table-column>
            <el-table-column prop="zhiwei_number" label="人数" align="center"></el-table-column>
            <el-table-column prop="$zhiwei_jianlis" label="查看简历" align="center">
              <template slot-scope="scope">
                <!--<el-icon name="search"></el-icon>-->
                <span class="search" @click="goHeard(scope.row.zhiwei_id)" style="color:black">{{ scope.row.$zhiwei_jianlis}}份简历</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="岗位描述" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="miaoshu(scope.row.zhiwei_jd,scope.row.zhiwei_name)">点击查看岗位描述</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="update" label="上传简历" align="center">
              <template slot-scope="scope">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  :show-file-list="false"
                  action="/api/zhaopin/zhiwei/uploadjianli2"
                  :data={zhiwei_id:scope.row.zhiwei_id}
                  :multiple=false
                  :auto-upload=true
                  :on-success="shuaXin"
                  :on-error="fail"
                  :on-progress="loading"
                  >
                  <el-button size="mini" >上传简历</el-button>
                  </el-upload>

              </template>
            </el-table-column>

            <el-table-column>
              <!--后端返回的1表示已是置顶状态，此时应该展示“取消置顶”；值是0表示没有置顶，展示“置顶”-->
              <template slot-scope="scope">
                <div class="operate hide">
                  <el-button type="text" size="small" >
                    <div v-if="scope.row.zhiwei_zhiding === 1" @click="downUp(scope.row.zhiwei_id)">取消置顶</div>
                    <div v-else @click="toTop(scope.row.zhiwei_id)">置顶</div>
                  </el-button>
                  <el-button type="text" size="small">
                    <div v-if="scope.row.zhiwei_neitui === 1" @click="cancleTui(scope.row.zhiwei_id)">取消内推</div>
                    <div v-else @click="neiTui(scope.row.zhiwei_id)">内推</div>
                  </el-button>
                  <el-button type="text" size="small" @click="pause(scope.row.zhiwei_id)">停招</el-button>
                  <el-button type="text" size="small" @click="change(scope.row.zhiwei_id)">修改</el-button>
                  <el-button type="text" size="small">
                    <div @click="sendMsg(scope.row.zhiwei_id)">发送邮件</div>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="clearfix">
          <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" :page-sizes="pageSizes" layout="total,sizes,prev, pager, next" :total="totalList">
            </el-pagination>
          </div>
        </div>

        <!--遮罩弹层-->
        <div class="dialog">
          <el-dialog title="添加职位信息" :visible.sync="centerDialogVisible" width="50%" :show-close="open" :close-on-click-modal="modal">
            <div class="dialog_table" >
              <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign" ref="formLabelAlign" :rules="rules">
                <el-form-item label="职位" prop="name">
                  <el-input v-model="formLabelAlign.name"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="department">
                  <DepartmentCascade align="left" size="middle" ref="cascadeTwo" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree" v-model="formLabelAlign.department" v-on:getDepartmentFour="showDepartmentFour" v-bind:four="parentMsgFour"></DepartmentCascade>
                </el-form-item>
                <el-form-item label="级别" prop="selectedOptions">
                  <el-cascader :options="options" v-model="formLabelAlign.selectedOptions" :clearable="true">
                  </el-cascader>
                </el-form-item>
                <el-form-item label="数量" prop="num">
                  <el-input v-model.number="formLabelAlign.num" maxlength="2"></el-input>
                </el-form-item>
                <el-form-item label="岗位描述" prop="content">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formLabelAlign.content"></el-input>
                </el-form-item>
                <el-form-item label="负责人" prop="responser">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formLabelAlign.responser" placeholder="多个负责人，“工号+英文逗号+工号”如：1,2,逗号必须是英文逗号"></el-input>
                </el-form-item>
                <el-form-item label="岗位标签" prop="radio">
                  <el-radio-group v-model="formLabelAlign.radio">
                    <el-radio-button label="上海"></el-radio-button>
                    <el-radio-button label="北京"></el-radio-button>
                    <el-radio-button label="广州"></el-radio-button>
                    <el-radio-button label="深圳"></el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="cancel('formLabelAlign')">取 消</el-button>
              <el-button @click="addInfo('formLabelAlign')">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <!--弹层end-->

        <!--修改弹层-->
        <div class="dialog">
          <el-dialog title="修改职位信息" :visible.sync="centerDialogVisible1" width="50%" :show-close="open" :close-on-click-modal="modal" :class="{isShow:!centerDialogVisible1?true:false}">
            <div class="dialog_table" >
              <el-form :label-position="labelPosition" label-width="80px" :model="form" ref="form" :rules="nrules">
                <el-form-item label="职位" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="部门" prop="department">
                  <DepartmentCascade align="left" size="middle" ref="cascadeTwo" v-bind:first="parentMsgOne" v-on:getDepartmentOne="showDepartmentOne" v-bind:second="parentMsgTwo" v-on:getDepartmentTwo="showDepartmentTwo" v-bind:third="parentMsgThree" v-on:getDepartmentThree="showDepartmentThree" v-model="formLabelAlign.department" v-on:getDepartmentFour="showDepartmentFour" v-bind:four="parentMsgFour"></DepartmentCascade>
                </el-form-item>
                <el-form-item label="级别" prop="selectedOptions">
                  <el-cascader :options="options" v-model="form.selectedOptions" :clearable="true">
                  </el-cascader>
                </el-form-item>
                <el-form-item label="数量" prop="num">
                  <el-input v-model.number="form.num" maxlength="2"></el-input>
                </el-form-item>
                <el-form-item label="岗位描述" prop="content">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.content"></el-input>
                </el-form-item>
                <el-form-item label="负责人" prop="responser">
                  <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="form.responser" placeholder="多个负责人，“工号+英文逗号+工号”如：1,2,逗号必须是英文逗号"></el-input>
                </el-form-item>
              </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="cancel('form')">取 消</el-button>
              <el-button @click="changeInfo('form')">修改</el-button>
            </span>
          </el-dialog>
        </div>
        <!--弹层end-->

        <!-- 岗位描述弹层 -->
        <el-dialog
          title=""
          :visible.sync="centerDialogVisible2"
          width="50%"
          center
          :show-close="false"
          top="200px">
          <span v-if="jd!==''" v-html="newJd"></span>
          <span v-else>{{name}}暂无岗位描述</span>
        </el-dialog>
        <!-- 岗位描述弹层end -->
    </div>
  <!-- </div> -->
</template>

<style lang="scss" scoped>
.title {
  font-size: 12px;
  color: #999999;
}
.isShow {
  display: none;
}
.table {
  &__wrap {
    margin-top: 20px;
    border-radius: 3px;
    background-color: rgba(255, 255, 255, 1);
  }
  &__nav {
    font-size: 16px;
    margin-bottom: 0; // padding-bottom: 1px;
    box-shadow: 0px 1px 0px 0px rgba(233, 233, 233, 1);
    a#{&}--active {
      color: rgba(255, 96, 2, 1);
      box-shadow: 0px 2px 0px 0px rgba(255, 96, 2, 1);
    }
    a {
      display: inline-block;
      text-decoration: none;
      line-height: 21px;
      font-size: 16px;
      text-align: center;
      padding: 10px 20px;
      text-align: center;
      color: #333333;
      span {
        color: rgba(0, 0, 0, 0.65);
        font-size: 12px;
        text-align: left;
        border-radius: 40px;
        border: 1px #d9d9d9 solid;
        padding: 0px 5px;
        margin-left: 5px;
        font-family: HelveticaNeue;
      }
    }
  }
  &__list {
    margin: 0px 20px 0 20px;
    border: 1px solid #e9e9e9;
  }
}

.table__search {
  font-size: 14px;
  color: #333333;
  padding: 20px;
}

.btn-add {
  // display:inline-block;
  color: #ffffff;
  font-size: 12px;
  width: 80px;
  height: 32px;
  border-radius: 3px;
  background-color: rgba(255, 96, 2, 1);
  padding: 10px 16px;
}

.pagination {
  float: right;
  padding: 10px;
}

.hide {
  visibility: hidden;
}

.search {
  cursor: pointer;
  color: #1989fa;
}

.el-select {
  width: 150px;
}

.el-select:not(:first-child) {
  margin-left: 10px;
}
</style>
<script>
import DepartmentCascade from '../components/DepartmentCascade.vue'
export default {
  props: ['zhiwei'],
  data () {
    return {
      modal: false,
      open: false,
      freshList: [],
      fileList: [],
      firstApart: '',
      firstApart1: '',
      mianshi: '',
      bannerData: {},
      activeName: 'first',
      centerDialogVisible: false,
      centerDialogVisible1: true,
      centerDialogVisible2: false,
      tableData: [],
      currentData: [],
      navIndex: 0,
      pageSize: 10,
      pageNum: 1,
      pageSizes: [10, 20, 50],
      totalList: 0,
      labelPosition: 'left',
      options: [
        {
          value: 'P',
          label: 'P',
          children: [
            {
              value: '1',
              label: '1',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '2',
              label: '2',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '3',
              label: '3',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '4',
              label: '4',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '5',
              label: '5',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '6',
              label: '6',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '7',
              label: '7',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '8',
              label: '8',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '9',
              label: '9',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            }
          ]
        },
        {
          value: 'M',
          label: 'M',
          children: [
            {
              value: '1',
              label: '1',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '2',
              label: '2',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '3',
              label: '3',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '4',
              label: '4',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '5',
              label: '5',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '6',
              label: '6',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '7',
              label: '7',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '8',
              label: '8',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            },
            {
              value: '9',
              label: '9',
              children: [
                {
                  value: '1',
                  label: '+'
                },
                {
                  value: '2',
                  label: '-'
                },
                {
                  value: '3',
                  label: '0'
                }
              ]
            }
          ]
        }
      ],
      // selectedOptions: [],
      selectedOptions2: [],
      formLabelAlign: {
        name: '',
        selectedOptions: [],
        num: '',
        content: '',
        department: '',
        responser: '',
        radio: ''
      },
      form: {
        name: '',
        selectedOptions: [],
        num: '',
        content: '',
        department: '',
        responser: ''
      },
      rules: {
        name: [
          { required: true, message: '职位必填', trigger: 'blur' },
          { max: 16, message: '职位名称最多16位', trigger: 'blur' }
        ],
        num: [
          {
            required: true,
            message: '数量必填',
            trigger: 'blur'
          },
          { type: 'number', message: '数量必须为数字值' }
        ],
        content: [
          { max: 1000, message: '岗位描述最多1000字', trigger: 'blur' },
          {
            required: true,
            message: '岗位描述必填',
            trigger: 'blur'
          }
        ],
        responser: [
          {
            required: true,
            message: '负责人必填',
            trigger: 'blur'
          }
        ],
        selectedOptions: [
          { required: true, message: '级别必填', trigger: 'change' }
        ],
        radio: [
          {
            required: true,
            message: '岗位标签必选'
          }
        ]
        // department: [{ required: true, message: "部门必填" }]
      },
      nrules: {
        name: [
          { required: true, message: '职位必填', trigger: 'blur' },
          { max: 16, message: '职位名称最多16位', trigger: 'blur' }
        ],
        num: [
          {
            required: true,
            message: '数量必填',
            trigger: 'blur'
          },
          { type: 'number', message: '数量必须为数字值' }
        ],
        content: [
          { max: 1000, message: '岗位描述最多1000字', trigger: 'blur' },
          {
            required: true,
            message: '岗位描述必填',
            trigger: 'blur'
          }
        ],
        responser: [
          {
            required: true,
            message: '负责人必填',
            trigger: 'blur'
          }
        ],
        selectedOptions: [
          { required: true, message: '级别必填', trigger: 'change' }
        ]
        // department: [{ required: true, message: "部门必填" }]
      },
      parentMsgOne: '',
      parentMsgTwo: '',
      parentMsgThree: '',
      parentMsgFour: '',
      secondApart: '',
      secondApart1: '',
      forthApart: '',
      forthApart1: '',
      thirdApart1: '',
      thirdApart: '',
      jd: '',
      name: '',
      newJd: ''
    }
  },
  components: {
    DepartmentCascade
  },
  created () {
    this.getBannerData()
    this.getData()
  },
  mounted () {
    this.centerDialogVisible1 = false
  },
  methods: {
    getBannerData () {
      var self = this
      this.$axios
        .get('/api/zhaopin2', {
          params: {}
        })
        .then(function (res) {
          self.$emit('allData', res.data)
          self.bannerData = res.data
        })
    },
    getData () {
      let self = this
      // 请求招聘默认列表接口
      this.$axios
        .post('/api/zhaopin/zhiwei2', {
          jiagou_first: this.firstApart1,
          jiagou_second: this.secondApart1,
          jiagou_third: this.thirdApart1,
          jiagou_forth: this.forthApart1
        })
        .then(function (response) {
          self.totalList = response.data.number
          self.tableData = response.data.zhiwei_data
          for (var i = 0; i < self.totalList; i++) {
            // self.formLabelAlign.selectedOptions = ["P", "2", "1"];
            var first_name = self.tableData[i]['jiagou_first_name']
            var second_name = self.tableData[i]['jiagou_second_name']
            var third_name = self.tableData[i]['jiagou_third_name']
            var forth_name = self.tableData[i]['jiagou_forth_name']
            self.tableData[i].zhiwei_zhiding = Math.round(Math.random() * 1)
            if (
              (second_name === '') &
              (third_name == '') &
              (forth_name == '')
            ) {
              self.tableData[i].list = first_name
            } else if ((third_name == '') & (forth_name == '')) {
              self.tableData[i].list = first_name + '/' + second_name
            } else if (forth_name == '') {
              self.tableData[i].list =
                first_name + '/' + second_name + '/' + third_name
            } else {
              self.tableData[i].list =
                first_name +
                '/' +
                second_name +
                '/' +
                third_name +
                '/' +
                forth_name
            }
          }
          self.getCurrentList()
        })
    },
    nav (index) {
      this.navIndex = index
    },
    showOperate (row, column, cell) {
      let targetEl = cell.parentElement.querySelector('.operate')
      targetEl.classList.remove('hide')
    },
    hideOperate (row, column, cell) {
      let targetEl = cell.parentElement.querySelector('.operate')
      targetEl.classList.add('hide')
    },
    getCurrentList () {
      this.currentData =
        this.tableData &&
        this.tableData.slice(
          (this.pageNum - 1) * this.pageSize,
          this.pageNum * this.pageSize
        )
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getCurrentList()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.getCurrentList()
    },
    // 查看招聘职位对应列表
    goHeard: function (id) {
      let self = this
      sessionStorage.setItem('id', JSON.stringify(id))
      self.$router.push({
        path: `/resume`,
        query: {
          id: id
        }
      })
    },
    // 置顶
    toTop: function (idd) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/up2 ', {
          zhiwei_id: idd
        })
        .then(function () {
          self.getData()
        })
    },
    // 取消置顶
    downUp: function (id) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/notup2 ', {
          zhiwei_id: id
        })
        .then(function () {
          self.getData()
        })
    },
    // 取消内推
    cancleTui: function (neitui_id) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/notneitui2 ', {
          zhiwei_id: neitui_id
        })
        .then(function () {
          self.getData()
        })
    },
    // 内推
    neiTui: function (neitui_id) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/neitui2 ', {
          zhiwei_id: neitui_id
        })
        .then(function () {
          self.getData()
        })
    },
    // 停招（删除）
    pause: function (tingzhao_id) {
      let self = this
      this.$axios
        .post('/api/zhaopin/zhiwei/delete2', {
          zhiwei_id: tingzhao_id
        })
        .then(function () {
          self.getData()
          self.getBannerData()
        })
    },
    showDepartmentOne: function (one) {
      this.firstApart = one
    },
    showDepartmentTwo: function (two) {
      if (!two) {
        this.secondApart = ''
      } else {
        this.secondApart = two
      }
    },
    showDepartmentThree: function (three) {
      this.thirdApart = three
    },
    showDepartmentFour (four) {
      this.forthApart = four
    },
    showDepartmentOne1: function (one) {
      let self = this
      this.firstApart1 = one
      self.getData()
    },
    showDepartmentTwo1: function (two) {
      let self = this
      this.secondApart1 = two
      self.getData()
    },
    showDepartmentThree1: function (three) {
      let self = this
      this.thirdApart1 = three
      self.getData()
    },
    showDepartmentFour1 (four) {
      let self = this
      this.forthApart1 = four
      self.getData()
    },

    addInfo (formName) {
      let self = this
      var level = this.formLabelAlign.selectedOptions
      if (level[2] === '1') {
        var third_level = '+'
        var new_level = level[0] + level[1] + third_level
      } else if (level[2] === '2') {
        third_level = '-'
        new_level = level[0] + level[1] + third_level
      } else {
        new_level = level[0] + level[1]
      }

      // 添加职位请求
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/zhaopin/zhiwei/addzhiwei2', {
              zhiwei_name: this.formLabelAlign.name,
              zhiwei_number: this.formLabelAlign.num,
              zhiwei_jd: this.formLabelAlign.content,
              jiagou_first: this.firstApart,
              zhiwei_jibie: new_level,
              jiagou_second: this.secondApart,
              jiagou_third: this.thirdApart,
              jiagou_forth: this.forthApart,
              zhiwei_responsor: this.formLabelAlign.responser,
              tag: this.formLabelAlign.radio
            })
            .then(function () {
              self.getData()
              self.getBannerData()
              self.$refs[formName].resetFields()
              self.$refs.cascadeTwo.getClear()
              self.centerDialogVisible = false
            })
        } else {
          // this.$message.error("除了岗位描述，其余字段都是必填");
          return false
        }
      })
    },
    change (id) {
      let self = this
      sessionStorage.setItem('id', id)
      this.$axios
        .post('/api/zhaopin/zhiwei2', {
          zhiwei_id: id
        })
        .then(function (res) {
          self.centerDialogVisible1 = true
          self.form.name = res.data.zhiwei_data[0].zhiwei_name
          self.form.num = res.data.zhiwei_data[0].zhiwei_number
          self.form.content = res.data.zhiwei_data[0].zhiwei_jd
          var jibie = res.data.zhiwei_data[0].zhiwei_jibie
          var jibie_list = jibie.split('')
          if (jibie_list.length === 2) {
            self.form.selectedOptions = jibie_list
          } else if ((jibie_list.length === 3) & (jibie_list[2] === '+')) {
            // var a = jibie_list.pop(jibie_list[2])
            // var b = jibie_list.push('1')
            self.form.selectedOptions = jibie_list
          } else if ((jibie_list.length === 3) & (jibie_list[2] === '-')) {
            // var c = jibie_list.pop(jibie_list[2])
            // var d = jibie_list.push('2')
            self.form.selectedOptions = jibie_list
          }
          self.form.responser = res.data.zhiwei_data[0].zhiwei_responsor
          self.parentMsgOne = res.data.zhiwei_data[0].jiagou_first
          self.parentMsgTwo = res.data.zhiwei_data[0].jiagou_second
          self.parentMsgThree = res.data.zhiwei_data[0].jiagou_third
          self.parentMsgFour = res.data.zhiwei_data[0].jiagou_forth
          if ((self.parentMsgOne !== '') & (self.parentMsgOne !== '-1')) {
            self.$refs.cascadeTwo.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo,
              self.parentMsgThree,
              self.parentMsgFour
            )
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo === '-1') &
            (self.parentMsgThree === '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeTwo.parentHandleclick(self.parentMsgOne)
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo !== '') &
            (self.parentMsgTwo !== '-1') &
            (self.parentMsgThree === '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeTwo.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo
            )
          }
          if (
            (self.parentMsgOne !== '') &
            (self.parentMsgOne !== '-1') &
            (self.parentMsgTwo !== '') &
            (self.parentMsgTwo !== '-1') &
            (self.parentMsgThree !== '') &
            (self.parentMsgThree !== '-1') &
            (self.parentMsgFour === '-1')
          ) {
            self.$refs.cascadeTwo.parentHandleclick(
              self.parentMsgOne,
              self.parentMsgTwo,
              self.parentMsgThree
            )
          }
        })
    },
    changeInfo (formName) {
      let self = this
      sessionStorage.getItem('id')

      var level = this.form.selectedOptions
      if (level[2] === '1') {
        var third_level = '+'
        var new_level = level[0] + level[1] + third_level
      } else if (level[2] === '2') {
        third_level = '-'
        new_level = level[0] + level[1] + third_level
      } else {
        new_level = level[0] + level[1]
      }

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('/api/zhaopin/zhiwei/changezhiwei2', {
              zhiwei_id: sessionStorage.getItem('id'),
              zhiwei_name: this.form.name,
              zhiwei_number: this.form.num,
              zhiwei_jd: this.form.content,
              jiagou_first: this.firstApart,
              zhiwei_jibie: new_level,
              jiagou_second: this.secondApart,
              jiagou_third: this.thirdApart,
              jiagou_forth: this.forthApart,
              zhiwei_responsor: this.form.responser
            })
            .then(function () {
              self.getData()
              self.centerDialogVisible1 = false
            })
        } else {
          // this.$message.error("除了岗位描述，其余字段都是必填");
          return false
        }
      })
    },
    cancel (formName) {
      this.$refs[formName].resetFields()
      this.$refs.cascadeTwo.getClear()
      this.centerDialogVisible = false
      this.centerDialogVisible1 = false
    },
    shuaXin () {
      let self = this
      this.$alert('文件上存成功', '提示', {
        center: true
      })
      self.getData()
      self.getBannerData()
    },
    fail () {
      let self = this
      this.$alert('文件上存失败', '提示', {
        center: true
      })
      self.getData()
    },
    loading () {
      const loading = this.$loading({
        lock: true,
        text: '文件上存中，请勿做其他操作',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      setTimeout(() => {
        loading.close()
      }, 2000)
    },
    sendMsg (id) {
      this.$axios
        .post('/api/zhaopin/notice', {
          zhiwei_id: id
        })
        .then(function (res) {
        })
    },
    miaoshu (zhiwei_jd, name) {
      let self = this
      var jd = zhiwei_jd
      self.jd = jd.replace(/\\n/gm, '<br/>')
      self.name = name
      self.newJd = self.name + self.jd
      self.centerDialogVisible2 = true
    }
  }
}
</script>
